import React, {forwardRef, Fragment, useImperativeHandle, useState} from "react";
import {TextBox} from "../../../form/TextBox";
import {Json} from "../../../basic/Json";
import {Title} from "../../../form/Title";

export const Users = forwardRef((props, ref) => {
    const [id, setId] = useState('');

    useImperativeHandle(ref, () => {
        return {
            getPathname: () => "/dashboard/user",
            getParameters: getParameters,
            createOutput: createOutput,
            handleGo: () => {}
        }
    })

    const getParameters = () => {
        return [
            {key: "id", value: id},
        ];
    }

    const createOutput = (json) => {
        return <Json json={json}/>
    }

    const handleIdChange = (value) => {
        setId(value);
    }

    return <Fragment>
        <Title>Parameter</Title>
        <TextBox title="Users ID" value={id} onChange={handleIdChange}/>
    </Fragment>
});